
export enum AlineacionEnum
{
  Izquierda = 1,
  Derecha,
  Centrada
}
